// extracted by mini-css-extract-plugin
export default {"newChatComponent":"newChat_newChatComponent__+U9Qz"};